import {Record, List} from 'immutable';

import * as Types from './types';

export class SavedList extends Record<Types.ListFromAPI>({
    id: '',
    name: '',
    filter: '',
    description: '',
    created: '',
    updated: '',
    private: false,
    editable: false,
    kind: Types.ListKind.Child,
    bookmarked: false,
}) {}

export class PresetList extends Record<Types.ListFromAPI>({
    id: '',
    name: '',
    filter: '',
    description: '',
    created: '',
    updated: '',
    private: false,
    editable: false,
    kind: Types.ListKind.Child,
    bookmarked: false,
    longName: '',
    preset: true,
}) {}

const fromAPI = (response: Types.ListsResponse) => {
    return {
        saved: List(response.saved.map(list => new SavedList(list))),
        preset: List(response.presets.map(list => new PresetList(list))),
    };
};

export default {
    fromAPI,
};
